/**
 * Compute the path of nodes and edges leading to a target node using BFS traversal.
 * Traverses backwards from the target node through incoming edges to find all ancestors.
 */ export function computePathToNode(targetNodeId, edges) {
    if (!targetNodeId) {
        return {
            nodeIds: new Set(),
            edgeIds: new Set()
        };
    }
    const nodeIds = new Set();
    const edgeIds = new Set();
    const incomingEdges = new Map();
    edges.forEach((edge)=>{
        if (!incomingEdges.has(edge.target)) {
            incomingEdges.set(edge.target, []);
        }
        incomingEdges.get(edge.target).push(edge);
    });
    const queue = [
        targetNodeId
    ];
    nodeIds.add(targetNodeId);
    while(queue.length > 0){
        const currentId = queue.shift();
        const incoming = incomingEdges.get(currentId) || [];
        for (const edge of incoming){
            edgeIds.add(edge.id);
            if (!nodeIds.has(edge.source)) {
                nodeIds.add(edge.source);
                queue.push(edge.source);
            }
        }
    }
    return {
        nodeIds,
        edgeIds
    };
}

//# sourceMappingURL=pathToNode.js.map